export interface IEmptyProviderFeature {
  slug: string;
  name: string;
}

export const getFeaturesMapper = (): Record<string, IEmptyProviderFeature> => ({
  'settings-activation-emails': {
    slug: 'emailAutomation',
    name: 'Email Automation'
  },
  'customer-import': {
    slug: 'inviteCustomers',
    name: 'Invite Customers'
  },
  'social-rewards': {
    slug: 'socialRewards',
    name: 'Social Rewards'
  },
  'referral-program': {
    slug: 'referralProgram',
    name: 'Referral Program'
  }
});
